import { useCallback } from 'react';
import { toString } from '../transformation';
export function useTransformations(formatter, parser) {
  var format = useCallback(function (v) {
    var normalized = toString(v);
    return formatter ? formatter(normalized) : normalized;
  }, [formatter]);
  var parse = useCallback(function (v) {
    return parser ? parser(v) : v;
  }, [parser]);
  return {
    format: format,
    parse: parse
  };
}